module.exports = __webpack_public_path__ + "static/media/Kissen_60x60_rueckseite.226c1b08.png";